import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { GetApiDoctorsPortalDoctors200 } from '@/shared/api/models';

export interface DoctorsListState {
    doctors: GetApiDoctorsPortalDoctors200['doctors'];
    currentPage: number;
    totalPages: number;
    limit: number;
    total: number;
    loading: boolean;
    error: string | null;
}

const initialState: DoctorsListState = {
    doctors: [],
    currentPage: 1,
    totalPages: 0,
    limit: 25,
    total: 0,
    loading: false,
    error: null,
};

const doctorsSlice = createSlice({
    name: 'doctorsList',
    initialState,
    reducers: {
        setDoctorsList: (state, action: PayloadAction<GetApiDoctorsPortalDoctors200>) => {
            const { doctors, currentPage, totalPages, limit, total } = action.payload;
            state.doctors = doctors;
            state.currentPage = currentPage;
            state.totalPages = totalPages;
            state.limit = limit;
            state.total = total;
            state.loading = false;
            state.error = null;
        },
        setDoctorsLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
            if (action.payload) state.error = null;
        },
        setDoctorsError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
            state.loading = false;
        },
        clearDoctorsList: () => initialState,
    },
});

export const { setDoctorsList, setDoctorsLoading, setDoctorsError, clearDoctorsList } = doctorsSlice.actions;
export default doctorsSlice.reducer;
